<template>
  <div class="teams-list-view container py-4">
    <div class="search-bar mb-4">
      <div class="input-group">
        <input 
          v-model="searchQuery" 
          type="text" 
          class="form-control" 
          placeholder="Bereiche durchsuchen..."
          @input="handleSearch"
        >
        <button 
          v-if="searchQuery" 
          class="btn btn-outline-secondary" 
          type="button" 
          @click="clearSearch"
          title="Suche löschen"
        >
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </div>
    
    <TeamsList />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useTeamsStore } from '@/stores/teams'
import TeamsList from '@/components/teams/TeamsList.vue'

const teamsStore = useTeamsStore()


const { searchQuery, teams } = storeToRefs(teamsStore)


const { fetchTeams, handleSearch } = teamsStore


const clearSearch = () => {
  searchQuery.value = ''
  handleSearch()
}

onMounted(async () => {
  if (teamsStore.teams.length === 0 || teamsStore.pagination.limit < 8) {
    teamsStore.pagination.limit = 8
    await fetchTeams()
  }
})
</script>

